import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';

export const CardPackGroupWrapper = styled(Vertical)`
  gap: var(--double-unit);
  @media ${laptopAndAbove} {
    display: grid;
    grid-template-columns: 2fr 3fr;
    gap: var(--triple-unit);
  }

  &.reverseDirection {
    flex-direction: column-reverse;
  }
`;
